/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from 'react';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { Spinner } from 'reactstrap';

// actions
import { fetchPublicQSEmbedUrl } from '../../actions/reports';

function PublicReport({ state }) {
  const ref = useRef();
  useEffect(() => {
    fetchPublicQSEmbedUrl(state)
      .then(({ data }) => {
        console.log('data: ', data);
        // Clear out the spinners.
        ref.current.innerHTML = '';

        createEmbeddingContext()
          .then((context) => {
            const { embedDashboard } = context;
            embedDashboard({
              url: data,
              container: ref.current,
              scrolling: 'yes',
              height: '100%',
              width: '100%',
            });
          });
      });
  }, []);

  return (
    <div className="container-fluid">
      <main className="bg-white power-bi" style={{ width: '100%' }}>
        <div id="powerbi-embed-div" ref={ref}>
          {/* NOTE: This spinner is automatically removed by the embed process. */}
          <div className="d-flex align-items-center justify-content-center h-100">
            <Spinner color="info" style={{ width: '6rem', height: '6rem' }} type="grow" />
            <Spinner color="info" style={{ width: '6rem', height: '6rem' }} type="grow" />
            <Spinner color="info" style={{ width: '6rem', height: '6rem' }} type="grow" />
          </div>
        </div>
      </main>
    </div>
  );
}

export default PublicReport;
